import React from "react";
import { motion } from "framer-motion";
import { FAQ } from "../lib/data";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FaqSection = () => {
  return (
    <section
      id="faq"
      className="relative py-28 md:py-40 bg-pw overflow-hidden"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="gold-line" />
            <span className="overline">FAQ</span>
            <span className="gold-line" />
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--pw-text)]">
            Le risposte alle <em className="text-[var(--pw-gold)]">domande</em> più frequenti.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[var(--pw-border)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif font-light text-xl md:text-2xl text-[var(--pw-text)] hover:text-[var(--pw-gold)] hover:no-underline py-6">
                  <span className="flex items-baseline gap-5">
                    <span className="text-[var(--pw-gold)] text-sm font-sans tracking-[0.25em]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{item.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[var(--pw-text)]/70 font-light text-base leading-relaxed pl-12 pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FaqSection;
